import { FcBusinessman, FcBusinesswoman, FcDecision } from "react-icons/fc"
import { TbLockAccess } from "react-icons/tb"
import { FiSmartphone } from "react-icons/fi"
import { AiOutlineMail } from "react-icons/ai"

import { useNavigate } from 'react-router-dom';


const UserList = ({ user }) => {

     const navigate = useNavigate()


     return (
          <div className="itemBox">
               <div className="dtr">
                    <div className="flex">

                         <div className="posterItem" style={{ fontSize: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {user.gender !== null ? user.gender === 1 ? <FcBusinessman /> : <FcBusinesswoman /> : <FcDecision />}
                         </div>

                         <div className="contentItem">
                              <p className="title">
                                   <span className="ltr ellipsis" style={{ float: 'right', marginLeft: '10px' }}>{user.firstName}</span>
                                   {user.lastName && (<><small className="ellipsis">({user.lastName})</small></>)}
                              </p>

                              <p className="">
                                   <FiSmartphone />
                                   {user.userName}
                              </p>
                              <p className="">
                                   <AiOutlineMail />
                                   <span>{user.email ? user.email : 'ندارد'}</span>
                              </p>

                              <p className="cats">
                                   <TbLockAccess />
                                   <span>{user?.role?.name ? user?.role?.name : 'ندارد'}</span>
                              </p>


                         </div>
                    </div>
               </div>
               <div className="dtl">
                    <button onClick={() => navigate(`/users/${user.userId}`, { state: { role: user?.role?.id }, replace: true })}>ویرایش کاربر</button>
                    <button className="disabled">User ID : {user.userId}</button>
               </div>
          </div>
     )
}

export default UserList